/**
 * 
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import axios from "axios";
import ServicePath from "@/core/ServicePath";
import {
    MainRequest
} from "@/core/request";

export default class ProductsRequest extends MainRequest{

    static addProducts(data){
        return this.postSEC(ServicePath.PRODUCTS_ADD, data)
    }
    
    static listAllProductsWiExistence(data){
        return this.postSEC(ServicePath.PRODUCTS_LIST_ALL_WITH_EXISTENCE, data)
    }

    static listAllProducts(){
        return this.getSEC(ServicePath.PRODUCTS_LIST_ALL)
    }

    static listAllProductsStock(){
        return this.getSEC(ServicePath.PRODUCTS_LIST_ALL_STOCK)
    }
    
    static updateProducts(data){
        return this.postSEC(ServicePath.PRODUCTS_UPDATE, data)
    }
    
    static deleteProducts(data){
        return this.postSEC(ServicePath.PRODUCTS_DELETE, data)
    }

}